'use strict';

const h = require('phy');

const VariablePricing = option => {
  const { variablePricing } = option || {};

  if (!variablePricing) {
    return null;
  }

  const {
    pricingMetadata: { offerLabelDescriptive, offerType },
    regularPrice: { formattedAmount },
  } = variablePricing;

  if (offerLabelDescriptive && formattedAmount) {
    const className =
      offerType === 'VARIABLE_PRICING_NEW'
        ? '.variable-pricing-new'
        : '.variable-pricing-repeat';
    return h(
      '.variable-pricing',
      h(
        `${className}`,
        h(`span${className}-price`, formattedAmount),
        h(`span${className}-text`, offerLabelDescriptive)
      )
    );
  }

  return null;
};

module.exports = VariablePricing;
